import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortal} from '@angular/cdk/portal';

@Directive({ selector: '[displacerPortal]' })
export class DisplacerPortalDirective extends TemplatePortal<any> {
	constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
		super(templateRef, viewContainerRef);
	}
}

